// Libs
import classNames from 'classnames/bind';
import { Chip } from '@mui/material';
// Components, Layouts, Pages
// Others
import { formatTitleCase } from '~/utils/helper/common';
import { ChipColorEnum, TagEnum } from '~/utils/enum/common';
// Styles, images, icons
import styles from './BaseTag.module.scss';

type Props = {
  label: string;
  height?: number;
};

const cx = classNames.bind(styles);

const BaseTag = (props: Props) => {
  //#region Destructuring Props
  const { label, height = 25 } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const getColor = () => {
    switch (label) {
      case TagEnum.PICK_UP:
        return ChipColorEnum.ERROR;
      default:
        return ChipColorEnum.DEFAULT;
    }
  };
  //#endregion Handle Function

  return (
    <Chip
      style={{ height }}
      classes={{
        root: cx('chip'),
        colorDefault: cx('backgroundDefault'),
        colorError: cx('backgroundError'),
        outlined: cx('outlined'),
      }}
      variant='outlined'
      color={getColor()}
      label={formatTitleCase(label)}
    />
  );
};

export default BaseTag;
